import { crossEnv } from '@sbvr/lbe-environment';

export function parseQueryString (): Record<string, string> {
  const url = new URL(location.href);
  const searchParams = new URLSearchParams(url.search.slice(1));

  return Array.from(searchParams.keys()).reduce((params, key) => {
    return {
      ...params,
      [key]: searchParams.get(key),
    };
  }, {});
};

export function addToQueryString (key: string, value: string) {
  const url = new URL(location.href);
  const searchParams = new URLSearchParams(url.search.slice(1));

  searchParams.set(key, value);
  url.search = searchParams.toString();
  window.history.replaceState({}, '', url.toString());
};

export function removeFromQueryString (key: string) {
  const url = new URL(location.href);
  const searchParams = new URLSearchParams(url.search.slice(1));
  searchParams.delete(key);
  url.search = searchParams.toString();
  window.history.replaceState({}, '', url.toString());
};

export function getCookieDomain () {
  if (window && crossEnv.NODE_ENV === 'development') {
    return location.host.includes('docker') ? '.springboardvr.docker' : location.hostname;
  } else {
    return '.springboardvr.com';
  }
};

export function stringify (params: Record<string|number, string>) {
  return `?${Object.keys(params).map(paramKey => paramKey + '=' + params[paramKey]).join('&')}`;
};
